import { Divider, Grid } from '@mui/material';
import React from 'react';

const OrderBookDivider: React.FC = () => (
  <Grid size={12}>
    <Divider />
  </Grid>
);

export default OrderBookDivider;
